import { Input, Option, Select } from '@material-tailwind/react'
import React from 'react'
import Search_Dropdown from '../Layout/Search_Dropdown'

export default function IntegrationBanner() {
    return (
        <div>
            <div className='section-padding 1350:pt-[6.25rem] 999:pt-[4rem] pt-[3rem]  '>
                <div className='text-center 1350:mb-[4.375rem] 999:mb-[3.5rem] mb-[3rem] '>
                    <h2 className='1650:text-[3.875rem] 1440:text-[3.2rem] 1350:text-[2.9rem] 768:text-[2.4rem] 600:text-[2rem] text-[2.4rem]  font-bold	 primary-text leading-[1.258]	'>Powerful Integration</h2>
                    <p className=' 1650:1350:text-[1.5rem]  1350:text-[1.2rem] 768:text-[1.1rem] 600:text-[1rem] text-[1.2rem] secondary-text font-[450]  leading-[1.20] pt-[.9375rem] pb-[.625rem]'>Lorem ipsum dolor sit amet consectetur. Pulvinar nunc egestas eleifend in vel erat. Massa velit sem aenean ultricies pellentesque est auctor duis placerat. Aliquet sed mi ullamcorper etiam non eu risus purus platea.</p>
                    <Search_Dropdown/>
                </div>
            </div>
        </div>
    )
}
